import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

export const RESPONSIVE_BREAKPOINT_VERSIONS = Object.freeze({
  LEGACY: 'legacy',
  V2: 'v2'
})

const ResponsiveBreakpointsContext = createContext(
  RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY
)

export const ResponsiveBreakpointsProvider = ({ value, children }) => (
  <ResponsiveBreakpointsContext.Provider value={value}>
    {children}
  </ResponsiveBreakpointsContext.Provider>
)

ResponsiveBreakpointsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.oneOf(Object.values(RESPONSIVE_BREAKPOINT_VERSIONS))
    .isRequired
}

export const useResponsiveBreakpointsVersion = () =>
  useContext(ResponsiveBreakpointsContext)

export default ResponsiveBreakpointsContext
